import {
  CHECKOUT_FULFILLED,
  CHECKOUT_REJECTED,
  CLEAR_CHECKOUT,
  INIT_CHECKOUT,
  UPDATE_CHECKOUT,
} from 'b2b-apps/shop/checkout/redux/checkout/actionTypes';
import {
  CheckoutFulfilledAction,
  CheckoutRejectedAction,
  ClearCheckoutAction,
  InitCheckoutAction,
  UpdateCheckoutAction,
} from 'b2b-apps/shop/checkout/redux/checkout/types';
import { CheckoutDataType, UpdateCheckoutRequestBodyType } from 'b2b-common/core/checkout/Checkout.types';

const checkoutFulfilled = (data: CheckoutDataType): CheckoutFulfilledAction => ({
  type: CHECKOUT_FULFILLED,
  payload: {
    data,
  },
});

const checkoutRejected = (error: ErrorType): CheckoutRejectedAction => ({
  type: CHECKOUT_REJECTED,
  payload: {
    error,
  },
});

const clearCheckout = (): ClearCheckoutAction => ({
  type: CLEAR_CHECKOUT,
});

const initCheckout = (): InitCheckoutAction => ({
  type: INIT_CHECKOUT,
});

const updateCheckout = (checkoutId: string, data: UpdateCheckoutRequestBodyType): UpdateCheckoutAction => ({
  type: UPDATE_CHECKOUT,
  payload: {
    checkoutId,
    data,
  },
});

export {
  checkoutFulfilled,
  checkoutRejected,
  clearCheckout,
  initCheckout,
  updateCheckout,
};
